/**
 * Namespace containing game difficulty ID constants
 * @namespace GameDifficultyId
 * @description Defines unique identifiers for different difficulty levels across various game types
 */
export namespace GameDifficultyId {
  // Mines (2-24 mines)
  /**
   * ID for Mines difficulty with 2 mines
   * @type {bigint}
   */
  export const Mines2: bigint = 1n;

  /**
   * ID for Mines difficulty with 3 mines
   * @type {bigint}
   */
  export const Mines3: bigint = 2n;

  /**
   * ID for Mines difficulty with 4 mines
   * @type {bigint}
   */
  export const Mines4: bigint = 3n;

  /**
   * ID for Mines difficulty with 5 mines
   * @type {bigint}
   */
  export const Mines5: bigint = 4n;

  /**
   * ID for Mines difficulty with 6 mines
   * @type {bigint}
   */
  export const Mines6: bigint = 5n;

  /**
   * ID for Mines difficulty with 7 mines
   * @type {bigint}
   */
  export const Mines7: bigint = 6n;

  /**
   * ID for Mines difficulty with 8 mines
   * @type {bigint}
   */
  export const Mines8: bigint = 7n;

  /**
   * ID for Mines difficulty with 9 mines
   * @type {bigint}
   */
  export const Mines9: bigint = 8n;

  /**
   * ID for Mines difficulty with 10 mines
   * @type {bigint}
   */
  export const Mines10: bigint = 9n;

  /**
   * ID for Mines difficulty with 11 mines
   * @type {bigint}
   */
  export const Mines11: bigint = 10n;

  /**
   * ID for Mines difficulty with 12 mines
   * @type {bigint}
   */
  export const Mines12: bigint = 11n;

  /**
   * ID for Mines difficulty with 13 mines
   * @type {bigint}
   */
  export const Mines13: bigint = 12n;

  /**
   * ID for Mines difficulty with 14 mines
   * @type {bigint}
   */
  export const Mines14: bigint = 13n;

  /**
   * ID for Mines difficulty with 15 mines
   * @type {bigint}
   */
  export const Mines15: bigint = 14n;

  /**
   * ID for Mines difficulty with 16 mines
   * @type {bigint}
   */
  export const Mines16: bigint = 15n;

  /**
   * ID for Mines difficulty with 17 mines
   * @type {bigint}
   */
  export const Mines17: bigint = 16n;

  /**
   * ID for Mines difficulty with 18 mines
   * @type {bigint}
   */
  export const Mines18: bigint = 17n;

  /**
   * ID for Mines difficulty with 19 mines
   * @type {bigint}
   */
  export const Mines19: bigint = 18n;

  /**
   * ID for Mines difficulty with 20 mines
   * @type {bigint}
   */
  export const Mines20: bigint = 19n;

  /**
   * ID for Mines difficulty with 21 mines
   * @type {bigint}
   */
  export const Mines21: bigint = 20n;

  /**
   * ID for Mines difficulty with 22 mines
   * @type {bigint}
   */
  export const Mines22: bigint = 21n;

  /**
   * ID for Mines difficulty with 23 mines
   * @type {bigint}
   */
  export const Mines23: bigint = 22n;

  /**
   * ID for Mines difficulty with 24 mines
   * @type {bigint}
   */
  export const Mines24: bigint = 23n;

  // Mission Uncrossable
  /**
   * Easy difficulty ID for Mission Uncrossable
   * @type {bigint}
   */
  export const MissionUncrossableEasy: bigint = 24n;

  /**
   * Medium difficulty ID for Mission Uncrossable
   * @type {bigint}
   */
  export const MissionUncrossableMedium: bigint = 25n;

  /**
   * Hard difficulty ID for Mission Uncrossable
   * @type {bigint}
   */
  export const MissionUncrossableHard: bigint = 26n;

  /**
   * Daredevil difficulty ID for Mission Uncrossable
   * @type {bigint}
   */
  export const MissionUncrossableDaredevil: bigint = 27n;

  // Tower
  /**
   * Easy difficulty ID for Tower
   * @type {bigint}
   */
  export const TowerEasy: bigint = 28n;

  /**
   * Medium difficulty ID for Tower
   * @type {bigint}
   */
  export const TowerMedium: bigint = 29n;

  /**
   * Hard difficulty ID for Tower
   * @type {bigint}
   */
  export const TowerHard: bigint = 30n;

  /**
   * Expert difficulty ID for Tower
   * @type {bigint}
   */
  export const TowerExpert: bigint = 31n;

  /**
   * Legendary difficulty ID for Tower
   * @type {bigint}
   */
  export const TowerLegendary: bigint = 32n;
}

/**
 * Type representing valid game difficulty IDs
 * @type {GameDifficultyIdType}
 */
export type GameDifficultyIdType =
  (typeof GameDifficultyId)[keyof typeof GameDifficultyId];
